<template>
  <div class="department_list">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="wrap-device-list_bg">
      <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
        <div class="filters">
          <div class="filter">
            <tree-select
                :options="status_list"
                :multiple="false"
                v-model="filter.status"
                :placeholder="translate('diadoc.history.status')"
                :clearable="true"
                @input="change_input"
            />
          </div>

          <div class="filter">
            <tree-select
                :options="validation_status_list"
                :multiple="false"
                v-model="filter.validation_status"
                :placeholder="translate('diadoc.history.validation_status')"
                :clearable="true"
                @input="change_input"
            />
          </div>

          <div class="filter"></div>
          <div class="filter"></div>
          <div class="filter"></div>
          <div class="filter"></div>
        </div>
      </div>
    </div>

    <div class="response_table">
      <div v-if="loading">
        <div class="spinner">
          <scale-loader />
        </div>
      </div>

      <table v-else>
        <thead>
          <tr>
            <th scope="col"> {{ translate('diadoc.history.document_file_name') }} / {{ translate('diadoc.history.document_title') }}</th>
            <th scope="col"> {{ translate('diadoc.history.missing_fields') }} </th>
            <th
                class="pointer"
                @click="change_filter('openai_model')"
                :class="{ selected: filter_type === 'openai_model' }"
                scope="col"
            >
              {{ translate('diadoc.history.openai_model') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('policy_name')"
                :class="{ selected: filter_type === 'policy_name' }"
                scope="col"
            >
              {{ translate('diadoc.history.policy_name') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('status')"
                :class="{ selected: filter_type === 'status' }"
                scope="col"
            >
              {{ translate('diadoc.history.status') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="w10per pointer"
                @click="change_filter('updated_at')"
                :class="{ selected: filter_type === 'updated_at' }"
                scope="col"
            >
              {{ translate('diadoc.history.updated_at') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
            <th
                class="pointer"
                @click="change_filter('validation_status')"
                :class="{ selected: filter_type === 'validation_status' }"
                scope="col"
            >
              {{ translate('diadoc.history.validation_status') }}
              <i
                  class="mdi mdi-arrow-down"
                  :class="{ reverse: filter_asc === 'desc' }"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
              class="department_item pointer"
              v-for="(history,key) in history_list"
              :key="key"
          >
            <td class="text-left" :data-label="translate('diadoc.history.document_file_name') + ' / ' + translate('diadoc.history.document_title')">
              <router-link :to="'/diadoc_document/' + history.diadoc_document_id">
                <p>{{ history.document_file_name }}</p>
                <p>{{ history.document_title }}</p>
              </router-link>
            </td>
            <td class="text-left" :data-label="translate('diadoc.history.missing_fields')">
              {{ history.missing_fields.length > 0 ? history.missing_fields : '' }}
            </td>
            <td :data-label="translate('diadoc.history.openai_model')"> {{ history.openai_model }} </td>
            <td class="text-left" :data-label="translate('diadoc.history.policy_name')"> {{ history.policy_name }} </td>
            <td :data-label="translate('diadoc.history.status')"> {{ normal_status(history.status) }} </td>
            <td class="w10per" :data-label="translate('diadoc.history.updated_at')" v-html="get_date_any_lines(history.updated_at, null, 2)"></td>
            <td :data-label="translate('diadoc.history.validation_status')"> {{ normal_validation_status(history.validation_status) }} </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DiadocHistories',
  components: {
  },
  data () {
    return {
      histories: [],
      loading: false,
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
      filter:{
        status: null,
        validation_status: null
      },
      filter_type: "",
      filter_asc: "asc",
    }
  },

  created () {
    this.get_diadoc_history_list()
  },

  watch:{

  },

  computed:{
    history_list () {
      const history_list = [...this.histories]
      return history_list.sort(this.compareNumbers)
    },
    status_list(){
      return [
        {id: 0, label: "В процессе / ещё не завершён"},
        {id: 1, label: "Разбор успешен, все нужные поля есть"},
        {id: 2, label: "Разбор прошёл, но есть missing fields"},
        {id: 3, label: "Ошибка разбора"},
      ]
    },
    validation_status_list(){
      return [
        {id: 0, label: "Валидация не запускалась"},
        {id: 1, label: "Ок"},
        {id: 2, label: "Есть предупреждения"},
        {id: 3, label: "Не прошло"}
      ]
    },
    send_filter(){
      let filter = {}
      Object.keys(this.filter).forEach((item) => {
        this.filter[item] !== null && this.filter[item] !== "" && this.filter[item] !== undefined ? filter[item] = this.filter[item] : ""
      })
      return filter
    },
  },

  methods: {
    normal_status(status){
      const find_status = this.status_list.find(item =>{
        if(item.id === status) return item
      })
      return find_status ? find_status.label : ""
    },
    normal_validation_status(status){
      const find_status = this.validation_status_list.find(item =>{
        if(item.id === status) return item
      })
      return find_status ? find_status.label : ""
    },
    change_input () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_diadoc_history_list, 500)
    },
    get_diadoc_history_list(){
      this.loading = true
      this.$http.v1.getDiadocDocumentParseHistory(this.send_filter, (response) => {
        this.histories = response.data
        this.loading = false
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
  }
}
</script>

<style lang="scss" scoped>
  .department_list {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;

    .header{
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 10px;
      .filters{
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        .filter{
          width: 100%;
          .form-group{
            margin: 0;
          }
        }
      }
    }

    .response_table{
      //padding: 10px 0 0;
      padding: 0;
      tbody{
        tr{
          font-size: 12px;
          td{
            a,p{
              font-size: 12px;
              margin-bottom: 0;
            }
          }
          &:hover{
            background-color: #eeeeee;
          }
        }

        .text-left{
          text-align: left;
        }

        .limit{
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 1.5em;
          max-height: 3em;
          margin-bottom: 0;
          font-size: 12px;
        }
      }
    }
  }
</style>
